import { Component, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavParams, ViewController, Events, NavController } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
import { ConfigProvider } from '../../providers/config/config';
import { CoLocationComponent } from '../../components/co-location/co-location';
import { LocationsProvider, Location } from '../../providers/locations/locations';
/**
 * Generated class for the CoBibHoldingListModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-bib-holding-list-modal',
  templateUrl: 'co-bib-holding-list-modal.html',
})
export class CoBibHoldingListModalPage {
  text: string;
  locationList: Array<any>;
  bibDetails: any;
  mapLocation: {lat: number, long: number} = {lat: 0, long: 0};
  allLocations: Array<Location>;
  hideMap: boolean = false;
  @Output() placeHoldOpen: EventEmitter<any> = new EventEmitter<any>();
  constructor(public navCtrl: NavController, private navParams : NavParams, public viewCtrl: ViewController, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider, private el:ElementRef, private state : AppState, public config: ConfigProvider, private locationsProvider : LocationsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.locationList = this.navParams.data.locations;
    this.locationsProvider.getLocations().then(all =>{
      this.allLocations = all;
      // console.log(all);
      this.locationList.map(loc => {
        loc.details = all.find(l => l.id === loc.location.locationID);
        return loc;
      });
    });
    if (this.locationList[0].location && this.locationList[0].location.position && this.locationList[0].location.position.latitude){
      this.mapLocation.lat = this.locationList[0].location.position.latitude;
      this.mapLocation.long = this.locationList[0].location.position.longitude;
      this.hideMap = false;
    } else {
      let nextLocation = this.locationList.find(a => {
        return (a.location && a.location.position && a.location.position.latitude)
      });
      if (nextLocation){
        this.mapLocation.lat = nextLocation.location.position.latitude;
        this.mapLocation.long = nextLocation.location.position.longitude;
        this.hideMap = false;
      } else {
        this.hideMap = true;
      }
    }
	  this.bibDetails = this.navParams.data.bib;
    this.locationList.sort(function(a, b) {
      return a.location.name.localeCompare(b.location.name, undefined, {numeric: true, sensitivity: 'base'});
    });
    if (this.state.pickupLocation) {
      let current = this.locationList.filter((l,i) => {
          return l.location.code.toLowerCase() == this.state.pickupLocation.toLowerCase();
      });
      let rest = this.locationList.filter((l,i) => {
        return l.location.code.toLowerCase() !== this.state.pickupLocation.toLowerCase();
      });
      this.locationList = current.concat(rest);
    }
    // console.log(this.locationList);
  }

  goToLocation(id) {
    if (id){
      this.config.load(this.state.appId).then(cfg => {
        this.navCtrl.push(CoLocationComponent, { location: id, showNavbar: true });
      });
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick(this.el.nativeElement);
  }

  close(){
    this.viewCtrl.dismiss().catch(err=>{});
  }

  placeHold(){
    this.viewCtrl.dismiss({placeHold: true});
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-bib-holding-list-modal/co-bib-holding-list-modal.ts